"use client";

export { domMax } from "../../framer-motion/dist/es/render/dom/features-max.mjs"